export var VidmStatusType;
(function (VidmStatusType) {
    VidmStatusType["Installed"] = "Identity Manager Installed";
    VidmStatusType["NotInstalled"] = "Identity Manager Not Found";
    VidmStatusType["InstallInprogress"] = "Identity Manager installation in progress";
    VidmStatusType["vIDMHostNameUnknown"] = "Identity Manager hostname is not known";
})(VidmStatusType || (VidmStatusType = {}));
